import React from 'react';
import { Logo, Meta, Name, Root, Thumbnail, Type } from './RestaurantInfo.styles';

export interface RestaurantInfoProps {
  name: string;
  type: string;
  logo: string;
  logoSize: { width: number; height: number };
}

/**
 * 식당 정보 (entity) — 원형 썸네일(로고) + 이름 + 타입
 * 출처: spec §1-2
 */
export function RestaurantInfo({ name, type, logo, logoSize }: RestaurantInfoProps) {
  return (
    <Root>
      <Thumbnail>
        <Logo
          src={logo}
          alt={`${name} 로고`}
          width={logoSize.width}
          height={logoSize.height}
        />
      </Thumbnail>
      <Meta>
        <Name>{name}</Name>
        <Type>{type}</Type>
      </Meta>
    </Root>
  );
}
